export function wrapInLanguage(language: string, data: Object) {
  return { language, content: { data } };
}
